import { Empty } from "antd";

export default function BasicEmpty ({text = 'No data'}) {
  return <Empty description= {text} />;
}